<script setup>
import {ref} from "vue";
import {slideToggle} from "../lib/animate/index.js";

const listEl = ref();
const visible = ref(false);

function handleClick() {
    slideToggle( listEl.value, 300, "easeLinear" ).then( () => visible.value = !visible.value );
}
</script>

<template>
    <div>
        <div class="hidden mb-10" ref="listEl">
            <slot></slot>
        </div>

        <div class="flex flex-row justify-center">
            <button class="button | p-5" @click.prevent="handleClick">
                {{ visible ? 'Voir moins' : 'Voir plus' }}
                <i class="fa-solid fa-chevron-up" v-if="visible"></i>
                <i class="fa-solid fa-chevron-down" v-if="!visible"></i>
            </button>
        </div>
    </div>
</template>